<app-success-generico [successGenerico]="alertSucesso" (alertFechou)="fecharAlertSucesso($event)">
</app-success-generico>
<app-loading-generico [loadingGenerico]="alertLoading"></app-loading-generico>
<app-confirma-exclusao [confirmaExclusao]="alertConfirmacao" (confirmaExclusaoFechou)="fecharAlertConfirmacao($event)">
</app-confirma-exclusao>
<app-error-generico [errorGenerico]="alertError" (alertErrorFechou)="fecharAlertError($event)"></app-error-generico>

@if (filiaisEmpresa && filiaisEmpresa?.length) {
  <div>
    <div class="row border-top border-bottom pt-3 pb-0">
      <div class="coluna-cnpj">
        <span class="label">CNPJ</span>
      </div>
      <div class="coluna-nome-empresa">
        <span class="label">NOME</span>
      </div>
      <div class="coluna-lixeira">
        <span class="label">EXCLUIR</span>
      </div>
    </div>
    @for (filial of filiaisEmpresa | paginate: { id: 'paginacaoFiliais',
      itemsPerPage: filiaisPorPagina,
      currentPage: paginaFilial,
      totalItems: $safeNavigationMigration(filiaisEmpresa?.length) }; track filial) {
      <div class="row border-top pt-3 pb-0">
        <div class="coluna-cnpj">
          <p class="paragrafo">{{filial.codigoCnpj | cnpj}}</p>
        </div>
        <div class="coluna-nome-empresa">
          <p class="paragrafo">{{filial.nomeRazaoSocial | camelCase}} - {{filial.nomeFantasia | camelCase}}</p>
        </div>
        <div class="coluna-lixeira">
          <button class="btn pt-0" id="btnExcluir" (click)="confirmaExclusao(filial.idEmpresa)"
            [disabled]="!('CadastrosDadosDaEmpresa' | usuarioPermissao:'Excluir' | async)" title="Excluir filial">
            <i class="fa fa-trash c-primary" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    }
  </div>
}

<!-- FOOTER-CARD - PAGINAÇÃO - EMPRESAS -->
@if (filiaisEmpresa && filiaisEmpresa?.length) {
  <div class="footer-card">
    <div>
      <app-select
        [value]="filiaisPorPagina"
        (change)="zeraPagina()"
        (valueChanges)="filiaisPorPagina = $event"
        name="filiaisPorPaginaName"
    [options]="[
    {name : 'Exibir 3 contatos' , value : '3'} ,
    {name : 'Exibir 6 contatos' , value : '6'} ,
    {name : 'Exibir 9 contatos' , value : '9'}

    ]"
        optionValue="value"
        optionText="name">
      </app-select>
    </div>
    <!-- Paginação CENTRAL -->
    <div>
      <pagination-controls class="my-pagination" id="paginacaoFiliais" directionLink="true"
        (pageChange)="paginaFilial = $event" responsive="true" previousLabel="Anterior" nextLabel="Próxima">
      </pagination-controls>
    </div>
    <div>
      <p><span class="itens-pagina">{{filiaisEmpresa.length}}</span> Registros foram encontrados</p>
    </div>
  </div>
}

@if (filiaisEmpresa && filiaisEmpresa?.length) {
  <div class="d-flex container-fluid m-0 p-0 mt-4 justify-content-center">
    <button class="botao px-5 me-auto" id="btnNovoFilial" [disabled]="!('CadastrosDadosDaEmpresa' | usuarioPermissao:'Incluir' | async)" routerLink="/adicionar-filial">NOVA FILIAL</button>
  </div>
}
<!-- CARREGAMENTO EMPRESAS -->
@if (filiaisEmpresa === null) {
  <div>
    <div class="text-center">
      <output class="spinner-border c-primary">
        <span class="visually-hidden">Consultando filiais da empresa ...</span>
      </output>
    </div>
    <p class="legenda-spinner">Consultando filiais da empresa ...</p>
  </div>
}

<!-- CASO DE ERRO EMPRESAS -->
@if (filiaisEmpresa === false) {
  <div class="text-center">
    <img src="/assets/img/erro.png" width="200px" alt="Erro">
    <p class="legenda-erro">Ocorreu um erro na consulta de filiais da empresa.</p>
  </div>
}

<!-- CASO DE ESTEJA VAZIO -->
@if (!filiaisEmpresa?.length && filiaisEmpresa !== null) {
  <div class="text-center">
    <img src="/assets/img/vazio.png" width="230px" alt="Erro">
    <p class="legenda-vazio">Não existem filiais para essa consulta.</p>
    <div class="d-flex container-fluid m-0 p-0 mt-4 justify-content-center">
      <button class="botao px-5 me-auto" routerLink="/adicionar-filial"
      [disabled]="!('CadastrosDadosDaEmpresa' | usuarioPermissao:'Incluir' | async)">NOVA FILIAL</button>
    </div>
  </div>
}
